module.exports = __webpack_public_path__ + "img/freespin_multiplier.16159eac.png";